import { render, staticRenderFns } from "./CountdownComponent.vue?vue&type=template&id=12135358&scoped=true"
import script from "./CountdownComponent.vue?vue&type=script&lang=js"
export * from "./CountdownComponent.vue?vue&type=script&lang=js"
import style0 from "./CountdownComponent.vue?vue&type=style&index=0&id=12135358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12135358",
  null
  
)

export default component.exports